import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { ICreditCard } from 'interfaces/IProductData';
import FieldText from 'components/Field/Text';
import { IPaymentModel } from 'interfaces/IPaymentModel';
import { paymentService } from 'services/PaymentService';
import { SvgIcon } from 'components/SvgIcon';
import Translate from 'components/Translate';

const styles = require('./creditCard.css');

interface IProps {
  creditCard: ICreditCard;
  askCVV: boolean;
}

interface IState extends IStateBase {
  model: IPaymentModel;
}

export default class CreditCard extends BaseComponent<IState, IProps> {
  componentDidMount() {
    this.bindModel(paymentService.getPayment(0));
  }

  public setCvv = (cvv: any) => {
    paymentService.setPaymentData(0, { cvv });
  }

  render() {
    if (!this.state) {
      return null;
    }

    const { model } = this.state;

    return (
      <div>

        <div className='chk-oneClickBuy__securityMessage'>
          <Translate term='Seus dados estão protegidos e encriptados' />
        </div>
        <div className={`${styles.component} ${!this.props.askCVV ? 'without-cvv' : null}`}>
          <div className='chk-creditCard__security'>
            <SvgIcon name='security_card' />
          </div>
          <div className='chk-creditCard__cardNumber'>
            <div><Translate term='Número do Cartão' /></div>
            <div className='chk-creditCard__number' id='credit-card-number-ocb'>{this.props.creditCard.identifier}</div>
          </div>
          <div className='chk-creditCard__content'>

            {this.props.askCVV
              ? <div><Translate term='Digite o Código de Segurança' /></div>
              : null
            }

            <div className='chk-creditCard__cvvBrand'>
              <div className='chk-creditCard__cvv'>
                {this.props.askCVV
                  ? <FieldText
                    id='credit-card-cvv'
                    label='CVV'
                    validation='required'
                    value={model.cvv}
                    inputProps={{
                      maxLength: 4
                    }}
                    InputLabelProps={{
                      className: 'credit-card-cvv-label'
                    }}
                    onChange={this.setCvv}
                  />
                  : null
                }
              </div>
              <div className='chk-creditCard__brand'>
                <SvgIcon name={`pm_${this.props.creditCard.brand}`} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Templates/Mobile/OneClickBuy/CreditCard/index.tsx